import React, { FC, Fragment } from 'react';
import { Button } from '@cokitchen/cokitchen-components';
import { useNavigate } from 'react-router-dom';
import { ProcurementType } from 'models/procurement.model';
import ProcurementStatusTag from '../procurement-status-tag';
import useExecutiveContext from 'contexts/executive.context/context';
import { formatCurrency, formatRequestDate } from 'utils/functions';

type Props = {
  procurement: ProcurementType;
};

const ExecutiveProcurementCard: FC<Props> = ({ procurement }) => {
  const { setProcurementToUpdate } = useExecutiveContext();
  const order_code = procurement?.code;
  const router = useNavigate();

  const updateProcurement = () => {
    setProcurementToUpdate(procurement);
    router(String(order_code));
  };

  return (
    <Fragment>
      <div className='border hover:bg-gray-11 border-gray-13 rounded-lg flex flex-col py-2'>
        <div className='grow'>
          <div className='flex border-b border-[#ECEDEF] pb-2 items-center gap-2 flex-wrap justify-between px-3'>
            <h4 className='font-medium  text-base cursor-pointer'>#{order_code}</h4>
            <ProcurementStatusTag type={procurement?.status} />
          </div>

          <div className='p-3 text-sm'>
            {procurement?.items?.map((item, i) => (
              <div key={i} className='flex  items-center '>
                <p>{item.ingredient.name} </p>
                <div className='bg-[#DCDBD5] inline-block mx-1 w-[5px] h-[5px] rounded-full' />
                <p className='text-sm text-gray-5'>
                  {item.quantity} {item.ingredient.unit_type || 'portions'} (
                  <span>
                    {formatCurrency(
                      Number(item.quantity) * Number(item.ingredient.min_vendor_price)
                    )}
                  </span>
                  )
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className='flex border-t border-[#ECEDEF] pb-2 text-xs items-center gap-2 flex-wrap justify-between mx-3 pt-2'>
          <p>Created {formatRequestDate(procurement.created_at)}</p>
          <Button
            className='text-xs'
            color='primary'
            variant='link'
            onClick={() => updateProcurement()}>
            View
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default ExecutiveProcurementCard;
